import { CellFormat, DdvDate } from '@ddv/models';

export function isDateValid(isInputRange: boolean, condition: CellFormat): { [key: string]: boolean } | null {
    if (isInputRange) {
        if (!condition.rangeFrom || !condition.rangeTo) {
            return { rangeMissing: true };
        }

        if (!DdvDate.isStringValidDate(condition.rangeFrom) || !DdvDate.isStringValidDate(condition.rangeTo)) {
            return { invalidDate: true };
        }

        const rangeFrom = DdvDate.fromUSFormat(condition.rangeFrom).toUSPaddedFormat();
        const rangeTo = DdvDate.fromUSFormat(condition.rangeTo).toUSPaddedFormat();

        if (rangeFrom > rangeTo) {
            return { invalidDate: true };
        }
    }

    if (!isInputRange && !DdvDate.isStringValidDate(condition.value ?? '')) {
        return { invalidDate: true };
    }

    return null;
}
